/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Mfa_Code_InvalidInputs */

const en_error_mfa_code_invalid = /** @type {(inputs: Error_Mfa_Code_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That code isn't right. Check it and try again.`)
};

/**
* | output |
* | --- |
* | "That code isn't right. Check it and try again." |
*
* @param {Error_Mfa_Code_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_mfa_code_invalid = /** @type {((inputs?: Error_Mfa_Code_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Mfa_Code_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_mfa_code_invalid(inputs)
});